import React from "react";
import { connect } from "react-redux";
import { TableHead } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import { compose } from "recompose";
import withStyles from "@material-ui/core/styles/withStyles";
import TableBody from "@material-ui/core/TableBody";
import CircleHeader from "./CircleHeader";
import CircleRow from "./CircleRow";

const styles = {
  root: {
    background: "black",
  },
  input: {
    color: "white",
    backgroundColor: "rgb(36, 48, 65)",
  },
};

const CircleTable = ({ data, user }) => {
  return (
    <div className="admin-table-fullheight">
      <Table data-testid="circle-table" stickyHeader>
        <TableHead>
          <CircleHeader />
        </TableHead>
        <TableBody style={{ borderTop: "none" }}>
          {data &&
            data.map((circle) => (
              <CircleRow circle={circle} user={user} key={circle.id} />
            ))}
        </TableBody>
      </Table>
    </div>
  );
};

const enhance = compose(connect(), withStyles(styles));

export default enhance(CircleTable);
